export enum CLIENT_PREVIEW_STORAGE_KEY {
  TENANT_USER_TOKEN = 'clientPreviewTenantUserToken',
}

export enum CLIENT_PREVIEW_ROUTE {
  PROJECTS = '/projects',
  CLIENTS = '/clients',
}

export enum CLIENT_PREVIEW_MODE {
  CLIENT_PREVIEW = 'client_preview',
}

export const CLIENT_PREVIEW_MODAL_TEXT = {
  title: 'Preview client dashboard?',
  okText: 'Preview Dashboard',
  cancelText: 'Cancel',
} as const;

export const CLIENT_PREVIEW_MESSAGE = {
  missingToken: 'Client preview token was not returned.',
  startFailed: 'Failed to start client preview.',
  missingTenantSession: 'Original tenant session was not found. Please sign in again.',
  returnedToTenant: 'Returned to tenant dashboard.',
  viewingAsPrefix: 'Previewing as',
  readOnly: 'Client preview is read-only.',
  accountSettingsDisabled: 'Exit preview to manage account settings.',
  modalBodyPrefix: 'You will preview ',
  modalBodySuffix: "'s client dashboard.",
  previewAsTooltip: (email: string) => `Preview as ${email}`,
  switchedToClient: (email: string) => `Previewing dashboard as ${email}`,
  previewAsLabel: (email: string) => `Preview dashboard as ${email}`,
} as const;
